<template>
    <v-app-bar app color="primary" tile class="main-app-bar" flat>
        <v-btn icon large exact @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title class="text-center">{{user.username}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon large @click="callUserSettingDrawer(true)">
            <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
    </v-app-bar>
</template>
<script>
export default {
    data: () => ({

    }),

    computed: {
        editOptions() {
            return this.user.id === this.$store.state.profile.activeProfile.id
        }
    }
}
</script>